import { render, staticRenderFns } from "./WritingTabsStatus.vue?vue&type=template&id=00f04d71&"
import script from "./WritingTabsStatus.vue?vue&type=script&lang=js&"
export * from "./WritingTabsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports